import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      {i18n.language === 'en' && (
        <button
          className="language-btn"
          onClick={() => changeLanguage('zh')}
        >
          中
        </button>
      )}
      {i18n.language === 'zh' && (
        <button
          className="language-btn"
          onClick={() => changeLanguage('en')}
        >
          EN
        </button>
      )}
    </div>
  );
};

export default LanguageSwitcher; 